import { render, staticRenderFns } from "./OrganismEscalationTemplate.vue?vue&type=template&id=9854b12a&scoped=true&"
import script from "./OrganismEscalationTemplate.vue?vue&type=script&lang=js&"
export * from "./OrganismEscalationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OrganismEscalationTemplate.vue?vue&type=style&index=0&id=9854b12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9854b12a",
  null
  
)

export default component.exports